import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { IGCCHoldings } from "@/types/IGCCHoldings";
import { getGCCHoldings } from "@/services/getGCCHoldings";

export const fetchPortfolioList = createAsyncThunk(
  "pro/GetGccHoldings",
  async ({ pageNumber, publicAddress , searchString }: { pageNumber: number; publicAddress: string; searchString: string }, // Use an object for parameters
         { rejectWithValue }) => {
    try {
      const data = await getGCCHoldings(pageNumber, publicAddress , searchString);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
interface PortfolioState {
  portfolios: IGCCHoldings[];
  pageNumber: number;
  loading: boolean;
  error: string | null;
}

const initialState: PortfolioState = {
  portfolios: [],
  pageNumber: -1,
  loading: true,
  error: null,
};

export const PortfolioSlice = createSlice({
  name: "portfolio_slice",
  initialState,
  reducers: {
    incrementPageNumber: (state) => {
      state.pageNumber += 1;
    },
    resetPageNumber: (state) => {
      state.pageNumber = -1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPortfolioList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchPortfolioList.fulfilled,
        (state, action: PayloadAction<IGCCHoldings[]>) => {
          const newPortfolios = action.payload;
          const ids = new Set(
            state.portfolios?.map((holding) => holding.subject.outId)
          );
          state.portfolios =
            state.pageNumber === 0
              ? newPortfolios
              : [
                  ...state.portfolios,
                  ...newPortfolios.filter(
                    (holding) => !ids.has(holding.subject.outId)
                  ),
                ];
          state.loading = false;
        }
      )
      .addCase(fetchPortfolioList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { incrementPageNumber, resetPageNumber } = PortfolioSlice.actions;

export default PortfolioSlice.reducer;
